import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BroadcastMessageComponent } from './components/broadcast-message/broadcast-message.component';
import { CommsRoutingModule } from './comms-routing.module';
import { CommsRootComponent } from './components/comms-root/comms-root.component';
import { SharedModule } from 'app/shared/modules/shared.module';
import { BroadcastMessageFilterComponent } from './components/broadcast-message-filter/broadcast-message-filter.component';
import { BroadcastMessageCreateComponent } from './components/broadcast-message-create/broadcast-message-create.component';
import { BroadcastMessageDetailComponent } from './components/broadcast-message-detail/broadcast-message-detail.component';
import { InquiryDetailComponent } from 'app/components/comms';
import { InquiryDetailInfoComponent } from 'app/components/comms';
import {
	UserFeedbackComponent,
	UserFeedbackDetailComponent,
	UserFeedbackFilterComponent,
} from 'app/components/user-feedback';
@NgModule({
	declarations: [
		CommsRootComponent,
		BroadcastMessageComponent,
		BroadcastMessageFilterComponent,
		BroadcastMessageCreateComponent,
		BroadcastMessageDetailComponent,
		InquiryDetailComponent,
		InquiryDetailInfoComponent,
		UserFeedbackComponent,
		UserFeedbackDetailComponent,
		UserFeedbackFilterComponent,
		UserFeedbackDetailComponent,
	],
	imports: [CommonModule, CommsRoutingModule, SharedModule],
	exports: [
		CommsRootComponent,
		BroadcastMessageComponent,
		BroadcastMessageFilterComponent,
		BroadcastMessageCreateComponent,
		BroadcastMessageDetailComponent,
		InquiryDetailComponent,
		InquiryDetailInfoComponent,
		UserFeedbackDetailComponent,
		UserFeedbackFilterComponent,
		UserFeedbackDetailComponent,
	],
})
export class CommsModule {}
